import { useEffect, useState } from "react";
import { ShapePreview } from "./common/ShapePreview";
import { ErrorBox } from "./common/ErrorBox";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useFormContext } from "react-hook-form";

export const ShapePicker = ({
  name,
  label,
  title,
  detailed_label,
  options,
  validation,
  errors,
  selectedColor

}) => {
  console.log("re-render shpaePicker");

  const { register, setValue, trigger } = useFormContext();

  const handleColorClick = (code) => {
    setValue(name, code,{ shouldValidate: true });  
  };

  return (
    <div className="bg-white/60 rounded-2xl shadow-sm border border-gray-200/60 p-3.5 transition-all duration-200 hover:bg-white/80 hover:shadow-md backdrop-blur-sm">
      <div className="flex justify-between items-start mb-2">
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        <AiOutlineInfoCircle className="text-gray-600 text-base cursor-pointer hover:text-gray-800 transition-colors flex-shrink-0" />
      </div>

      <p className="text-sm text-gray-600 mb-3">{detailed_label}</p>

      <div className="flex flex-wrap gap-x-4 gap-y-3 mt-1">
        {options.map((shape, i) => (
          <div key={i} className="flex flex-col items-center" style={{ width: '56px' }}>
            <ShapePreview
              code={shape.code}
              color={shape.color}
              diameter={56}
              handleColorClick={handleColorClick}
              label={shape.label}
              selected={selectedColor == shape.code}
            />
            <label className="text-[9px] mt-1.5 text-center text-gray-600 dark:text-gray-400 font-medium leading-tight w-full break-words" title={shape.label}>
              {shape.label}
            </label>
          </div>
        ))}
      </div>

      <input type="hidden" {...register(name, validation)} />
      <ErrorBox errors={errors} />
    </div>
  );
};
